export default "__VITE_ASSET__D9F4KLfp__"